<template>
<div id="location-popup">
  <div class="row">
    <div class="col-md-12">
       <img :src="imageUrl">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'LocationPopUp',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#location-popup {
  img {
    width: 100%;
  }
}

.tooltip .tooltip-arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/LocationPopUp.vue